export const VIBO_REFRESH_TOKEN_KEY = 'x-refresh-token';
export const VIBO_TOKEN_KEY = 'x-token';
export const VIBO_VERSION_KEY = 'x-client-version';
export const VIBO_CLIENT_KEY = 'x-client-type';
export const DEVICE_KEY = 'device';
